<template>
    <div>
        <div class="add-funds blue-gr">
            <div class="add-funds__wrap">
                <div class="add-funds__wrap--info">
                    <strong>&#x20B9;{{totalAccountValue | localeAmount}}</strong>
                    <p class="mb-0">Total Account Value</p>
                </div>
                <router-link to="/funds">
                    <button class="btn btn-sm btn-secondary px-20">
                        Add Funds
                    </button>
                </router-link>
            </div>
            <div class="add-funds__wrap">
                <div class="add-funds__wrap--info">
                    <strong>&#x20B9;{{investedAmount | localeAmount}}</strong>
                    <p class="mb-0">Amount Invested</p>
                </div>
            </div>
        </div>
        <div class="add-funds blue-gr">
            <div class="add-funds__wrap">
                <div class="add-funds__wrap--info">
                    <strong>&#x20B9;{{escrowBalance | localeAmount}}</strong>
                    <p class="mb-0">Escrow Wallet Balance</p>
                </div>
                <router-link to="/invest">
                    <button class="btn btn-sm btn-secondary px-20">Invest</button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'addFundsCard',
    data () {
        return {
            totalAccountValue: null,
            investedAmount: null,
            escrowBalance: null
        }
    },
    mounted () {
        const chartDetails = this.$store.getters['dashboard/getChartDetails']
        this.totalAccountValue = chartDetails.totalAccountValue
        this.investedAmount = chartDetails.investedAmount
        this.escrowBalance = chartDetails.escrowBalance
        this.expectedEarning = chartDetails.expectedEarning
    }
}
</script>
<style lang="scss" scoped>
    .add-funds {
        &__wrap {
            @include flex(flex, center, space-between);
            &--info {
                strong {
                    font-size: $h3-font-size;
                }
            }
            .btn {
                border-radius: 30px;
            }
            &:not(:last-child) {
                margin-bottom: 30px;
            }
        }
    }
</style>
